(function () {
    'use strict';

    angular.module("imApp").factory("domObjectTypeMenuService", ['$ihttp', function ($ihttp) {
        let service = {
            getDomObjectTypeMenu: function (parms) {
                return $ihttp.post({
                    method: 3017,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
